
export default {
  i18nComponentKey: 'ReviewsNew.components.AiClothingDetectionInfoDialog',
  name: 'AiClothingDetectionInfoDialog'
};
